module.exports = __webpack_public_path__ + "static/media/como-29.42084d0e.jpg";